// extracted by mini-css-extract-plugin
export default {"logoImage":"styles_logoImage__p6awP","title":"styles_title__r8OkZ","loginContainer":"styles_loginContainer__02xhj","backButton":"styles_backButton__l3bkc"};